import { ContestPosterModal } from './contest/ContestPosterModal'
import { useContestPromoPopup } from '../hooks/useContestPromoPopup'

export function ContestPromoPopup() {
  const { open, dismiss } = useContestPromoPopup()
  return <ContestPosterModal open={open} onDismiss={dismiss} showCta />
}
